import "./CartProductCard.css";
import { UOM } from "../../../features/createSecondaryOrder/CreateSecondaryOrderType";
import { ReactComponent as TrashIcon } from "../../../assets/image/svg/trsahIcon.svg";
import { getStockCountColors } from "../LoadoutUtils";
import dummyProductImage from "../../../assets/image/png/dummyProduct.png";
import { CartProductCardProps } from "./types";
import { getUomLabel } from "../../dms_common/DmsUtils";
import { getUnitLabel } from "../../createSecondaryOrder/CartProductCardUtils";
import { truncateToTwoDecimals } from "../../dms_common/DmsUtils";
import FreeProductSvgLoadout from "../../../assets/image/svg/FreeProductSvgLoadout.svg";

const CartProductCard: React.FC<CartProductCardProps> = ({
  product,
  updateQuantity,
  configObj,
  preseller,
  batchIdConfiguration,
}) => {
  const { caseUnitLabel, otherUnitLabel, packUnitLabel } = getUomLabel();
  const {
    batchCode,
    skuCode,
    caseQuantity,
    pieceQuantity,
    otherUnitQuantity,
    availableCaseQty,
    availablePieceQty,
    availableOtherQty,
    imageUrl,
    name,
    otherUnitPrice,
    casePtr,
    packPtr,
    case2Piece,
    pieceSize,
    batchId,
    mrp,
    otherUnitName,
    itemType,
  } = product;
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const { displayOtherUnitName } = ConfigDictionary;
  let customOtherUnitLabel = displayOtherUnitName
    ? otherUnitName && otherUnitName.length > 0
      ? otherUnitName
      : otherUnitLabel
    : otherUnitLabel;

  const handleAddQuantity = (type: string) => {
    if (type === UOM.CASE) {
      updateQuantity(batchCode, caseQuantity + 1, UOM.CASE);
    } else {
      updateQuantity(batchCode, pieceQuantity + 1, UOM.PIECE);
    }
  };

  const handleRemoveQuantity = (type: string) => {
    if (type === UOM.CASE) {
      updateQuantity(batchCode, Math.max(caseQuantity - 1, 0), UOM.CASE);
    } else {
      updateQuantity(batchCode, Math.max(pieceQuantity - 1, 0), UOM.PIECE);
    }
  };

  const handleDeleteQuantity = () => {
    if (caseQuantity) {
      updateQuantity(batchCode, 0, UOM.CASE);
    }
    if (pieceQuantity) {
      updateQuantity(batchCode, 0, UOM.PIECE);
    }
  };

  const isInStock = Boolean(
    availableCaseQty || availablePieceQty || availableOtherQty
  );

  const { bg, text } = getStockCountColors(isInStock);

  const isValidQuantity = (type: UOM) => {
    if (type === UOM.PIECE) {
      return Number(availablePieceQty) > Number(pieceQuantity);
    } else if (type === UOM.OTHER) {
      return Number(availableOtherQty) > Number(otherUnitQuantity);
    } else {
      return Number(availableCaseQty) > Number(caseQuantity);
    }
  };

  const getAddButtonStyles = () => {
    return isInStock
      ? {}
      : { cursor: "not-allowed", backgroundColor: bg, color: text };
  };

  const getDisabledButtonStyling = () => {
    return {
      cursor: "not-allowed",
      backgroundColor: "#F4F4F4",
      color: "#7C7C7C",
    };
  };

  return (
    <>
      {isInStock && (
        <div className="CartProductCard">
          {!preseller && (
            <div onClick={handleDeleteQuantity} className="cart_remove_item">
              <TrashIcon width={12} height={15} />
            </div>
          )}
          <div
            style={{
              marginBottom: 0,
              display: "flex",
              justifyContent: "space-between",
              height: itemType?.toLowerCase() === "freeitem" ? "100%" : "",
              flexDirection: "column",
            }}
            className="CartProductCard_image_container_loadout"
          >
            {itemType?.toLowerCase() === "freeitem" && (
              <img
                src={FreeProductSvgLoadout}
                alt="Free Product"
                width={25}
                height={25}
              />
            )}
            <img
              src={imageUrl ?? dummyProductImage}
              alt={name}
              style={{ width: imageUrl ? "92%" : "80%", fontSize: "0.5rem" }}
            />
          </div>
          <div className="CartProductCard_details_container">
            <div style={{ lineHeight: "1.4" }}>
              <span style={{ fontWeight: 600 }}>{name}</span>
              {skuCode ? (
                <span
                  style={{ color: "#909090", marginLeft: 6 }}
                >{`(${skuCode})`}</span>
              ) : null}
            </div>
            <div style={{ fontWeight: 500 }}>{pieceSize}</div>
            {mrp !== undefined && mrp !== null && (
              <div style={{ color: "#676767" }}>
                MRP* {configObj.currencySymbol} {mrp}
              </div>
            )}
            {batchIdConfiguration && (
              <div>
                <span style={{ color: "#909090", letterSpacing: 0 }}>
                  Batch ID:{" "}
                </span>
                <span style={{ color: "#909090", letterSpacing: 0 }}>{`${
                  batchId ?? "N/A"
                }`}</span>
              </div>
            )}
          </div>
          <div
            style={{ alignItems: "center" }}
            className="CartProductCard_button_container_parent"
          >
            <div className="CartProductCard_button_container">
              {caseUnitLabel && (
                <div
                  className="CartProductCard_uom_div"
                  style={{ width: "fit-content", minWidth: "77px" }}
                >
                  <div className="price_box CartProductCard_text_overflow">
                    <span style={{ color: "#5C5C5C", fontWeight: 550 }}>
                      {configObj.currencySymbol}
                      &nbsp;
                      {truncateToTwoDecimals(casePtr)}
                    </span>
                    <span style={{ color: "#7C7C7C", fontSize: "9px" }}>
                      /{configObj.caseUnitLabel}
                    </span>
                  </div>
                  {caseQuantity === 0 || preseller ? (
                    <div
                      onClick={() => {
                        isValidQuantity(UOM.CASE) &&
                          updateQuantity(batchCode, 1, UOM.CASE);
                      }}
                      className="add_and_unit_button"
                      style={getAddButtonStyles()}
                    >
                      {preseller
                        ? `${caseQuantity} ${getUnitLabel(caseQuantity)}`
                        : "ADD"}
                      {!preseller && (
                        <span className="unit_text">{`${case2Piece} ${getUnitLabel(
                          case2Piece
                        )}`}</span>
                      )}
                    </div>
                  ) : (
                    <div className="quantity_box">
                      <div
                        onClick={() => {
                          handleRemoveQuantity(UOM.CASE);
                        }}
                        className="decrement_button"
                      >
                        <span className="increment_decrement_icon">-</span>
                      </div>
                      <div className="quantity_input_container">
                        <input
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={caseQuantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            let numericValue = Number(value);
                            if (!isNaN(numericValue)) {
                              numericValue =
                                numericValue > availableCaseQty
                                  ? availableCaseQty
                                  : numericValue;
                              updateQuantity(batchCode, numericValue, UOM.CASE);
                            }
                          }}
                          className="quantity_input"
                        />
                      </div>
                      <div
                        onClick={() => {
                          isValidQuantity(UOM.CASE) &&
                            handleAddQuantity(UOM.CASE);
                        }}
                        className="increment_button"
                        style={
                          isValidQuantity(UOM.CASE)
                            ? {}
                            : getDisabledButtonStyling()
                        }
                      >
                        <span
                          className="increment_decrement_icon"
                          style={
                            isValidQuantity(UOM.CASE)
                              ? {}
                              : getDisabledButtonStyling()
                          }
                        >
                          +
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {customOtherUnitLabel && (
                <div
                  className="CartProductCard_uom_div"
                  style={{ width: "fit-content", minWidth: "77px" }}
                >
                  <div className="price_box CartProductCard_text_overflow">
                    <span style={{ color: "#5C5C5C", fontWeight: 550 }}>
                      {configObj.currencySymbol}
                      &nbsp;
                      {truncateToTwoDecimals(otherUnitPrice)}
                    </span>
                    <span style={{ color: "#7C7C7C", fontSize: "9px" }}>
                      /{customOtherUnitLabel?.toUpperCase().slice(0, 3)}
                    </span>
                  </div>
                  {otherUnitQuantity === 0 || preseller ? (
                    <div
                      onClick={() => {
                        isValidQuantity(UOM.OTHER) &&
                          updateQuantity(batchCode, 1, UOM.OTHER);
                      }}
                      className="add_and_unit_button"
                      style={getAddButtonStyles()}
                    >
                      {preseller
                        ? `${otherUnitQuantity} ${getUnitLabel(
                            otherUnitQuantity
                          )}`
                        : "ADD"}
                      {!preseller && (
                        <span className="unit_text">{`1 ${getUnitLabel(
                          1
                        )}`}</span>
                      )}
                    </div>
                  ) : (
                    <div className="quantity_box">
                      <div
                        onClick={() => {
                          handleRemoveQuantity(UOM.OTHER);
                        }}
                        className="decrement_button"
                      >
                        <span className="increment_decrement_icon">-</span>
                      </div>
                      <div className="quantity_input_container">
                        <input
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={otherUnitQuantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            let numericValue = Number(value);
                            if (!isNaN(numericValue)) {
                              numericValue =
                                numericValue > availableOtherQty
                                  ? availableOtherQty
                                  : numericValue;
                              updateQuantity(
                                batchCode,
                                numericValue,
                                UOM.OTHER
                              );
                            }
                          }}
                          className="quantity_input"
                        />
                      </div>
                      <div
                        onClick={() => {
                          isValidQuantity(UOM.OTHER) &&
                            handleAddQuantity(UOM.OTHER);
                        }}
                        className="increment_button"
                        style={
                          isValidQuantity(UOM.OTHER)
                            ? {}
                            : getDisabledButtonStyling()
                        }
                      >
                        <span
                          className="increment_decrement_icon"
                          style={
                            isValidQuantity(UOM.OTHER)
                              ? {}
                              : getDisabledButtonStyling()
                          }
                        >
                          +
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {packUnitLabel && (
                <div
                  className="CartProductCard_uom_div"
                  style={{ width: "fit-content", minWidth: "77px" }}
                >
                  <div className="price_box CartProductCard_text_overflow">
                    <span style={{ color: "#5C5C5C", fontWeight: 550 }}>
                      {configObj.currencySymbol}
                      &nbsp;
                      {truncateToTwoDecimals(packPtr)}
                    </span>
                    <span style={{ color: "#7C7C7C", fontSize: "9px" }}>
                      /{configObj.packUnitLabel}
                    </span>
                  </div>
                  {pieceQuantity === 0 || preseller ? (
                    <div
                      onClick={() => {
                        isValidQuantity(UOM.PIECE) &&
                          updateQuantity(batchCode, 1, UOM.PIECE);
                      }}
                      className="add_and_unit_button"
                      style={getAddButtonStyles()}
                    >
                      {preseller
                        ? `${pieceQuantity} ${getUnitLabel(pieceQuantity)}`
                        : "ADD"}
                      {!preseller && (
                        <span className="unit_text">{`1 ${getUnitLabel(
                          1
                        )}`}</span>
                      )}
                    </div>
                  ) : (
                    <div className="quantity_box">
                      <div
                        onClick={() => {
                          handleRemoveQuantity(UOM.PIECE);
                        }}
                        className="decrement_button"
                      >
                        <span className="increment_decrement_icon">-</span>
                      </div>
                      <div className="quantity_input_container">
                        <input
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={pieceQuantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            let numericValue = Number(value);
                            if (!isNaN(numericValue)) {
                              numericValue =
                                numericValue > availablePieceQty
                                  ? availablePieceQty
                                  : numericValue;
                              updateQuantity(
                                batchCode,
                                numericValue,
                                UOM.PIECE
                              );
                            }
                          }}
                          className="quantity_input"
                        />
                      </div>
                      <div
                        onClick={() => {
                          isValidQuantity(UOM.PIECE) &&
                            handleAddQuantity(UOM.PIECE);
                        }}
                        className="increment_button"
                        style={
                          isValidQuantity(UOM.PIECE)
                            ? {}
                            : getDisabledButtonStyling()
                        }
                      >
                        <span
                          className="increment_decrement_icon"
                          style={
                            isValidQuantity(UOM.PIECE)
                              ? {}
                              : getDisabledButtonStyling()
                          }
                        >
                          +
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CartProductCard;
